var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "29px",
    viewBox: "0 0 30 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117.000000, -5822.000000)",
    stroke: "#5A5F65",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.000000, 5800.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.0894747,16 L12.260311,16 C8.24916202,16 5,19.2273534 5,23.2112723 L5,31.1093324 C5,34.611607 7.55784212,37.5654815 10.912659,38.183934 L10.9815351,42.2012994 C10.9815351,42.7163903 11.2921519,43.1965923 11.7769886,43.4031781 C11.9849654,43.5064641 12.1578438,43.54 12.3644515,43.54 C12.6750683,43.54 12.9519144,43.436714 13.1936481,43.265017 L19.6584364,38.3208314 L26.089689,38.3208314 C30.100838,38.3208314 33.35,35.093478 33.35,31.1095591 L33.35,23.2114989 C33.35,19.2274427 30.1006997,16 26.089689,16 L26.0894747,16 Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8bd6954a.svg";
export { ForwardRef as ReactComponent };